import React from 'react'
import './UserEmptyForm.scss';
export default function UserEmptyForm() {
    return (
        <div className="UserEmptyForm">
            <div>
                <strong>To edit a user</strong>
                <strong>select user on the table</strong>
            </div>
            <div>
                <strong>To crate a user</strong>
                <strong>Click the FAB button</strong>
                <strong>↓</strong>
	    </div>	
        </div>
    )
}
